module.exports = __webpack_public_path__ + "img/calculate-banner.58f81dab.png";